import * as React from 'react';
// import moment from 'moment';
// import 'moment/locale/es';
// import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
// import type { Match } from 'react-router-dom';
// import es from 'date-fns/locale/es';

// import 'react-datepicker/dist/react-datepicker.css';

import { apiPost } from '../services/api';
// import QueryString from 'query-string';
// import { CSSTransition } from 'react-transition-group';


const Form = () => {
    const cosa = async e => { 
        e.preventDefault();
        let attendant1Name  = document.getElementById("attendant1").value;
        let attendant2Name  = document.getElementById("attendant2").value;
        let attendant1Email = document.getElementById("email1").value;
        let attendant2Email = document.getElementById("email2").value;
        let meetingTime     = Date.parse(document.getElementById("meeting-time").value);
        let duration        = document.getElementById("duration").value;
        let proyectoID      = document.getElementById("proyectoID").value;
        console.log(proyectoID);
        if(attendant1Name  !== '' && attendant2Name !== '' && attendant1Email !== '' && attendant2Email &&  !isNaN(meetingTime) && duration !== '' && proyectoID !== ''){

        
        const createRequest = await apiPost(`createSession`, 
        {
          "type": "videocall",
          "scheduledDatetime": meetingTime,
          "duration": 3600,
          "proyectoID": proyectoID,
          "attendants": [
            {
              "role": "publisher",
              "data": {
                "name": attendant1Name,
                "email": attendant1Email,
                "idCRM": ""
              }
            },
            {
              "role": "publisher",
              "data": {
                "name": attendant2Name,
                "email": attendant2Email,
                "idCRM": ""
                }
            }
        ]
        });

        if(createRequest){
          alert("Sessión creada con éxito, recibiran un email");
        }
      }else{
        alert("Rellene todos los datos antes de poder crear la sesión");
      }
      
    }
     return (
      <>
       <form action="" method="post" id="createSession">
       <input type="text" name="attendant1" id="attendant1" placeholder="Nombre primer usuario" required/>
        <input type="email" name="email1" id="email1" placeholder="Email primer usuario" required/>
       <input type="text" name="attendant2" id="attendant2" placeholder="Nombre segundo usuario" required/>
        <input type="email" name="email2" id="email2" placeholder="Email segundo usuario" required/>
        <input type="datetime-local" id="meeting-time" name="fecha" required/>
        <input type="text" name="proyectoID" id="proyectoID" defaultValue="Default" required/>
        <input type="hidden" name="duration" id="duration" value="3600"/>
        <button 
        
        onClick={cosa}>Crear sesión</button> 
       </form>
      </>
    );
  };

class createSessionPage extends React.Component {
    // constructor(props) {
    //     super(props);

    //     this.handleClick = this.handleClick.bind(this);
    //   }
    render() {
      return (
        <>
            <Form />
        </>
      );
    }
}

export default createSessionPage;
